export const pegaHora = (data: string) => {
    const date = new Date(data)
    return `${('00' + date.getHours()).substr(-2)}:${('00' + date.getMinutes()).substr(-2)}`
}